module.exports = __webpack_public_path__ + "img/x3.c2ce7980.jpg";